<template>
  <div>
    <Toolbar :handle-reset="resetForm" :handle-submit="onSendForm"></Toolbar>
    <BackendUserForm :errors="violations" :values="item" ref="createForm"/>
    <Loading :visible="isLoading"/>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import BackendUserForm from '../../components/backenduser/CreateForm';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'BackendUser';

const {mapFields} = createHelpers({
  getterType: 'backendUser/getField',
  mutationType: 'backendUser/updateField'
});

export default {
  name: 'BackendUserCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    BackendUserForm
  },
  data() {
    return {
      item: {
        profile: {}
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('backendUser', ['create', 'reset']),
    getItemSubs() {
      return {
        profile: {}
      }
    }
  }
};
</script>
